import GdprRedirect from './GdprRedirect';

export default GdprRedirect;
